import React from 'react'

export default function WithSubtitle ({ children, subtitle = null, className = '', color = 'text-gray-500' }) {
  return (
    <div className={'flex flex-col ' + className}>
      {children}
      <div className={color + ' text-sm w-full'}>
        {subtitle || ' '}
      </div>
    </div>
  )
}
